import { FC, useEffect } from "react";
import { Box, Button, Modal, Typography } from "@mui/material";
import { useSingleUserControl } from "../../../context/SuperAdmin/SingleUserControlContext";

interface Props {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const AssignAdminModal: FC<Props> = ({ isOpen, setIsOpen }) => {
  const { isCreatingAdmin, createAdminDeDominio } = useSingleUserControl();

  const handleClose = () => {
    if (!isCreatingAdmin) {
      setIsOpen(false);
    }
  };

  // Cerramos el popup cuando se ejecute la función
  useEffect(() => {
    if (!isCreatingAdmin && isOpen) {
      handleClose();
    }
  }, [isCreatingAdmin]);

  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "rgba(0, 0, 0, 0.3)", // Fondo negro con opacidad
      }}
    >
      <Box
        component={"div"}
        sx={{
          width: 400,
          bgcolor: "background.paper", // Fondo blanco del modal
          borderRadius: 2, // Bordes redondeados
          p: 4,
          boxShadow: 24,
          minWidth: "600px",
          display: "flex",
          flexDirection: "column",
          gap: 3,
        }}
      >
        <Typography component={"h3"} sx={{ fontSize: "20px", fontWeight: 600 }}>
          ¿Quieres asignar este usuario como "Admin de Dominio"?
        </Typography>

        <Typography sx={{ mb: 1 }}>
          El usuario podra ver, crear, editar y eliminar organizaciones,
          suscripciones, roles y usuarios
        </Typography>
        <Box
          sx={{
            textAlign: "right",
            display: "flex",
            justifyContent: "flex-end",
            gap: 3,
            mt: 3,
          }}
        >
          <Button
            variant="outlined"
            onClick={() => setIsOpen(false)}
            disabled={isCreatingAdmin}
            sx={{
              borderRadius: 14,
              border: "1px solid #336B87",
              color: "#336B87",
              "&:hover": {
                backgroundColor: "#336B87",
                color: "#EEF3F6",
              },
            }}
          >
            Cancelar
          </Button>
          <Button
            variant="contained"
            sx={{ background: "#336B87" }}
            disabled={isCreatingAdmin}
            onClick={createAdminDeDominio}
          >
            Confirmar
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default AssignAdminModal;
